/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkExperience } from '../../models/work-experience';

export interface GetWorkExperiences$Params {
  profileId: string;
}

export function getWorkExperiences(http: HttpClient, rootUrl: string, params: GetWorkExperiences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkExperience>>> {
  const rb = new RequestBuilder(rootUrl, getWorkExperiences.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkExperience>>;
    })
  );
}

getWorkExperiences.PATH = '/studentprofile/{profileId}/workexperience';
